import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../constants";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../../services/serviceCaller";
import { FaSpinner } from "react-icons/fa";

const LeaveEncashmentEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Leaves Encashment"));
  }, []);

  const initialData = {
    EmployeeName: "",
    LeaveBalance: "",
    LeaveCarryForward: "",
    LeaveEncashment: "",
  };
  const [formData, setFormData] = useState(initialData);
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchLeaveData = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}leave/encashment/${id}`
      );
      const fetchData = response?.data?.data?.leaveEncashments;
      console.log("fetchData", fetchData);

      const leaveData = {
        ID: fetchData?.ID,
        EmployeeName: fetchData?.EmployeeName,
        LeaveBalance: parseInt(fetchData?.LeaveBalance, 10),
        LeaveCarryForward: parseInt(fetchData?.LeaveCarryForward, 10),
        LeaveEncashment: parseInt(fetchData?.LeaveEncash, 10),
      };
      setFormData(leaveData);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };
  useEffect(() => {
    if (id) {
      fetchLeaveData(id);
    }
  }, []);
  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   // Validate LeaveCarryForward input
  //   if (name === "LeaveCarryForward") {
  //     const leaveCarryForward = parseInt(value) || 0;

  //     // Prevent values above 10
  //     if (leaveCarryForward > 10) {
  //       toast.error("Leave Carry Forward cannot be greater than 10.");
  //       return;
  //     }
  //   }

  //   // Update the formData state
  //   setFormData((prev) => {
  //     const updatedFormData = { ...prev, [name]: value };

  //     // Calculate LeaveEncashment when LeaveCarryForward changes
  //     if (name === "LeaveCarryForward") {
  //       const leaveCarryForward = parseInt(value) || 0;
  //       const leaveBalance = parseInt(prev.LeaveBalance) || 0;
  //       updatedFormData.LeaveEncashment = Math.max(
  //         leaveBalance - leaveCarryForward,
  //         0
  //       );
  //     }

  //     return updatedFormData;
  //   });
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validate LeaveCarryForward input
    if (name === "LeaveCarryForward") {
      const leaveCarryForward = parseInt(value) || 0;
      const leaveBalance = parseInt(formData.LeaveBalance) || 0; // Use formData to get the latest LeaveBalance

      // Prevent values above 10
      if (leaveCarryForward > 10) {
        toast.error("Leave Carry Forward cannot be greater than 10.");
        return;
      }

      // Prevent LeaveCarryForward from being greater than LeaveBalance
      if (leaveCarryForward > leaveBalance) {
        toast.error(
          "Leave Carry Forward cannot be greater than Leave Balance."
        );
        return;
      }
    }

    // Update the formData state
    setFormData((prev) => {
      const updatedFormData = { ...prev, [name]: value };

      // Calculate LeaveEncashment when LeaveCarryForward changes
      if (name === "LeaveCarryForward") {
        const leaveCarryForward = parseInt(value) || 0;
        const leaveBalance = parseInt(prev.LeaveBalance) || 0;
        updatedFormData.LeaveEncashment = Math.max(
          leaveBalance - leaveCarryForward,
          0
        );
      }

      return updatedFormData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { LeaveBalance, LeaveCarryForward, LeaveEncashment } = formData;
    const LeaveEncash = LeaveEncashment;
    const submitLeaveData = { LeaveBalance, LeaveCarryForward, LeaveEncash };

    try {
      const response = await PostFormServiceCaller(
        `${API_URL}leave/encashment/${id}`,
        submitLeaveData,
        "put"
      );

      if (response.status === 200) {
        toast.success("Leave Encashment submitted successfully!");
        setTimeout(() => {
          navigate("/leave-encashment-report");
        }, 2000);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Failed to submit form. Please try again later.");
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-3">
                  <div className="mb-3">
                    <label for="Code" class="form-label">
                      Employee
                    </label>
                    <input
                      type="text"
                      name="EmployeeName"
                      id="EmployeeName"
                      value={formData.EmployeeName}
                      className="form-control"
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div>
                    <label for="Code" className="form-label">
                      Leave Balance
                    </label>
                    <input
                      type="text"
                      name="LeaveBalance"
                      id="LeaveBalance"
                      value={formData?.LeaveBalance}
                      className="form-control text-end"
                      disabled
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div class="mb-3">
                    <label for="Code" className="form-label">
                      Leave Carry Forward
                    </label>
                    <input
                      type="text"
                      name="LeaveCarryForward"
                      id="LeaveCarryForward"
                      value={formData?.LeaveCarryForward}
                      className="form-control text-end"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div class="mb-3">
                    <label for="Code" className="form-label">
                      Leave Encash
                    </label>
                    <input
                      type="text"
                      name="LeaveEncashment"
                      id="LeaveEncashment"
                      value={formData?.LeaveEncashment}
                      className="form-control text-end"
                      disabled
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button
                  className="cancel-btn me-2"
                  onClick={() => navigate("/leave-encashment-report")}
                >
                  Cancel
                </button>
                <button type="submit" className="custom-btn">
                  {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
};

export default LeaveEncashmentEdit;
